import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import App from './App';
import './index.css';

import { AuthProvider } from './features/auth/AuthContext';
import { ErrorBoundary } from './components/ErrorBoundary';
import { ConfirmProvider, ToastProvider } from '@examflow/ui';
import { PlatformSettingsProvider } from './features/platform/PlatformSettingsContext';
import { QuizRuntimeLaunchProvider } from './features/quiz/QuizRuntimeLaunchProvider';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000,
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <AuthProvider>
            <PlatformSettingsProvider>
              <ToastProvider>
                <ConfirmProvider>
                  <QuizRuntimeLaunchProvider>
                    <App />
                  </QuizRuntimeLaunchProvider>
                </ConfirmProvider>
              </ToastProvider>
            </PlatformSettingsProvider>
          </AuthProvider>
        </BrowserRouter>
      </QueryClientProvider>
    </ErrorBoundary>
  </React.StrictMode>
);
